import axiosInstance from ".";


export const createProduct = async ({ formData }) => {
    const response = await axiosInstance.post(`/supplier/products/`, formData, {
        "Content-Type": "multipart/form-data",
    })
    return response;
}
export const updateProduct = async ({ formData, productId }) => {
    const response = await axiosInstance.patch(`/supplier/products/${productId}`, formData, {
        "Content-Type": "multipart/form-data",
    })
    return response;
}
export const updateProductSequence = async ({ formData, productId }) => {
    const response = await axiosInstance.post(`/supplier/products/update-sequence/${productId}`, formData)
    return response;
}

export const getAllProducts = async () => {
    const response = await axiosInstance.get("/products")
    return response;
}

export const getProductById = async ({ id }) => {
    const response = await axiosInstance.get(`/supplier/products/product-by-id/${id}`)
    return response;
}

export const getProductsBySupplier = async ({ supplierId }) => {
    const response = await axiosInstance.get(`/supplier/products/${supplierId}`)
    return response;
}


export const deleteProduct = async ({ productId }) => {
    const response = await axiosInstance.delete(`/supplier/products/${productId}`)
    return response;
}

